export const environment = {
  name: 'production',
  production: true,
  hmr: false,
  apiUrl2: 'https://api.mediego.com',
  sentryDsn: 'https://927482a1eff5e8d3dd0bd4a2a7469531@o385232.ingest.us.sentry.io/4511371884298240'
};
